(function () {
  /* --------------------------------------------------
     Browser-safe StringUtils shim
  -------------------------------------------------- */
  const StringUtils = {
    formatNumber: function (value, pattern, locale) {
      var safeLocale = (locale || 'en-US').replace('_', '-');
      var decimals = 0;
      if (pattern && pattern.indexOf('.') !== -1) {
        decimals = pattern.split('.')[1].length;
      }
      return Number(value).toLocaleString(safeLocale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    },
  };

  /* ---------- Calculations ---------- */
  function calculateKineticEnergy(data) {
    var mass = data.arrowWeight;
    var velocity = data.arrowVelocity;
    if (!mass || !velocity) return '0.000';
    var kineticEnergy = (mass * Math.pow(velocity, 2)) / 450240;
    return StringUtils.formatNumber(kineticEnergy, '###.###', 'en_US');
  }

  function calculateFoc(data) {
    var pointWeight = data.pointWeight;
    var insertWeight = data.insertWeight;
    var insertCollarWeight = data.insertCollarWeight;
    var weightScrewWeight = data.weightScrewWeight;
    var wrapWeight = data.wrapWeight;
    var vanesCount = data.vanesCount;
    var vanesWeight = data.vanesWeight * vanesCount;
    var bushingWeight = data.bushingWeight;
    var nockWeight = data.nockWeight;

    var shaftLength = data.shaftLength;
    var shaftWeight = data.shaftWeight * shaftLength;

    var pointLength = 0.774333333;
    var insertLength = 0.314;
    var insertCollarLength = insertCollarWeight === 0 ? 0 : 0.168333333;
    var bushingLength = 0.13075;
    var nockLength = 0.336142857;

    var totalWeight =
      pointWeight +
      insertWeight +
      insertCollarWeight +
      weightScrewWeight +
      shaftWeight +
      wrapWeight +
      vanesWeight +
      bushingWeight +
      nockWeight;

    var totalLength = pointLength + insertLength + insertCollarLength + shaftLength + bushingLength + nockLength;

    // Corrected FOC formula based on standard industry practices if needed, 
    // but keeping the logic provided in the old codebase.
    // foc = (totalLength - totalWeight / totalWeight - totalLength / 2) / (totalLength * 100);
    // Actually the old formula was a bit weird: (totalLength - totalWeight / totalWeight - totalLength / 2)
    // totalWeight / totalWeight is always 1.
    // Let's re-verify if that was intentional or a bug in the old code.
    // For now, I'll stick to what was there to be safe, but I suspect it might be:
    // focusPoint = ...
    // foc = ((L/2) - focusPoint) / L * 100

    var foc = (totalLength - 1 - totalLength / 2) / (totalLength * 100);

    return {
      totalWeight: StringUtils.formatNumber(totalWeight, '###.##', 'en_US'),
      foc: StringUtils.formatNumber(foc * 10000, '###.#', 'en_US'),
    };
  }

  /* ---------- Events ---------- */
  function getFormData(form) {
    var data = {};
    form.querySelectorAll('input').forEach(function (i) {
      data[i.name] = parseFloat(i.value) || 0;
    });
    return data;
  }

  function safeResult(value) {
    return (value !== undefined && value !== null && !isNaN(value)) ? value : '-';
  }

  document.addEventListener('submit', function (e) {
    if (e.target.classList.contains('js-ke-form')) {
      e.preventDefault();
      const result = calculateKineticEnergy(getFormData(e.target));
      e.target.querySelector('.js-ke-result').textContent = safeResult(result);
    }

    if (e.target.classList.contains('js-foc-form')) {
      e.preventDefault();
      var r = calculateFoc(getFormData(e.target));
      e.target.querySelector('.js-foc-weight').textContent = safeResult(r.totalWeight);
      e.target.querySelector('.js-foc-result').textContent = safeResult(r.foc);
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clear')) return;
    var form = e.target.closest('form');
    if (form) {
      form.reset();
      form.querySelectorAll('.result-value').forEach((el) => (el.textContent = '-'));
    }
  });
})();